<div class="m-3">
    <h2> {{ "signed_off" | translate }} </h2>

    <a routerLink="/login">{{ "return_to_login" | translate }}</a>
</div>
